import { useEffect, useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./successFull.scss";
import Sidenav from "../../navbar/Sidenav";

export default function FailedView() {
    const navigate = useNavigate();
    const location = useLocation();

  // read query params
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const tenant_id = params.get("tenant_id") || "";
  const plan_name = params.get("plan_name") || "";

  // read optional state (fallbacks)
  const {
    planName = plan_name || "Premium Plan",
    redirect = { path: "/admin/tenant/details" },
    seconds = 10,
  } = location.state || {};

  const [countdown, setCountdown] = useState(seconds);

  // build final redirect url including tenant_id (+ plan_name if you want)
  const redirectUrl = useMemo(() => {
    const qs = new URLSearchParams();
    if (tenant_id) qs.set("tenant_id", tenant_id);
    if (plan_name) qs.set("plan_name", plan_name); // optional
    const query = qs.toString();
    return query ? `${redirect.path}?${query}` : redirect.path;
  }, [redirect.path, tenant_id, plan_name]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          navigate(redirectUrl, { replace: true });
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [navigate, redirectUrl]);


    const handleCancel = () => {
        navigate(redirect.path, { replace: true });
    };

    return (
        <>
            <div className="sf-wrapper sf-failure d-flex align-items-center justify-content-center">


                <div className="sf-card">
                    <div className="sf-content position-relative text-center">
                        <div className="sf-bg-text " style={{fontSize:'70px'}}>Payment Failed !</div>

                        <div className="sf-illustration">

                            <div className="sf-gold-coin sf-fail-coin">!</div>

                            <div className="sf-credit-card sf-fail-card">
                                <div className="sf-cc-line"></div>
                                <div className="sf-cc-line short"></div>
                                <div className="sf-cc-bottom"></div>
                            </div>

                            <div className="sf-phone-wrap">
                                <div className="sf-hand"></div>

                                <div className="sf-phone sf-fail-phone">
                                    <div className="sf-speaker"></div>
                                    <div className="sf-phone-screen">
                                        <div className="sf-success-icon sf-fail-icon">✕</div>
                                        <div className="sf-success-bar sf-fail-bar"></div>
                                    </div>
                                </div>

                                <div className="sf-float sf-fail-float">!</div>
                            </div>
                        </div>

                        <h2 className="sf-title">
                            Your Payment has Failed
                        </h2>

                        <p className="sf-description">
                            We couldn't process your transaction for {planName}. Please check your payment
                            details and try again later.
                        </p>

                        {seconds !== null && (
                            <div className="sf-countdown">
                                Redirecting in <strong>{countdown}</strong> seconds
                            </div>
                        )}

                        <div className="sf-button-group">
                            <button
                                onClick={handleCancel}
                                className="sf-cancel-btn"
                            >
                                Back to Dashboard
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}